import {
  Box,
  Breadcrumbs,
  CircularProgress,
  Grid,
  Link,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import { ModalCompany } from '../../../components/ModalCompany';
import { ModalService } from '../../../components/ModalService';
import { Link as RouterLink, useHistory, useParams } from 'react-router-dom';
import { ROUTES } from '../../../../../constants/routes';
import { CustomSelect } from '../../../../../components/CustomSelect';
import { CustomDateTimePicker } from '../../../../../components/CustomDateTimePicker';
import { CustomDatePicker } from '../../../../../components/CustomDatePicker';
import { ReactComponent as SettingsIcon } from '../../../../../assets/images/settingsIcon.svg';
import { ENTITY, TYPE_COMPANY, TYPE_EVENTS } from '../../../constants';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {
  actionsGetEvent,
  getBonusesCompany,
  getBonusesBranches,
  getBonusesPackages,
  getCmsPackages,
  getCopyEventById,
  getEventById,
  getTriggers,
  postCreateEvent,
  postUploadFiles,
  updateEvent, deleteFiles
} from '../../../../../store/bonuses/actions';
import { CustomInputTextArea } from '../../../../../components/CustomInputTextArea';
import { CustomInput } from '../../../../../components/CustomInput';
import { CustomRadioGroup } from '../../../../../components/CustomRadioGroup';
import { UploadFiles } from '../../../../../components/UploadFiles';
import { dataCreateEvent, initialValuesForm, validationFiles, validationSchema } from '../utils';
import { CustomSwitch } from '../../../../../components/CustomSwitch';
import { CustomButton } from '../../../../../components/CustomButton';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { ADD_EVENT_MODE } from '../../../constants/addEventMode';
import { visibleBySectionPermission } from '../../../../../utils/visibleBySectionPermission';
import { PERMISSIONS } from '../../../../../constants/variables';
import { CustomMultiSelect } from '../../../../../components/CustomMultiSelect';
import { setUsersPermissions } from '../../../../../utils/setUsersPermissions';
import { NumericFormat } from 'react-number-format';
import { ReactComponent as ReportRedIcon } from '../../../../../assets/images/report_red.svg';
import { CustomModal } from '../../../../../components/CustomModal';
import { getBonusCardMailingTemplates } from '../../../../../store/mailing/actions';
import { getAssetUrl } from '../../../../../utils/getAssetUrl';

const mainStyleInput = {
  variant: 'outlined',
  size: 'small'
};

export const AddEventFirstStep = ({moveToNextStep, fields = {}}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();
  const [showModalCompany, setShowModalCompany] = useState(false);
  const [showModalService, setShowModalService] = useState(false);
  const [entity, setEntity] = useState(ENTITY[0].value);
  const [customTouched, setCustomTouched] = useState({});
  const [service, setService] = useState([]);
  const [updatesFieldsStatus, setUpdatesFieldsStatus] = useState({
    packages: false,
    cities: false
  });
  const [errorModal, setErrorModal] = useState(false);
  const [isActiveSMSTemplateModal, setIsActiveSMSTemplateModal] = useState({
    open: false,
    hasOpened: false
  });

  // Temporary not showing packages, Task=382736
  // const { companyBonuses, branches, packages, cms, eventCard, triggers, uploadFiles, errorCard } =
  const { companyBonuses, branches, cms, eventCard, triggers, uploadFiles, errorCard, fetching } =
    useSelector((state) => state.bonuses);
  cms?.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
  const { bonusCardTemplates } = useSelector((state) => state.mailing);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  const cities = branches
    ?.map((city, index, array) => array.findIndex(item => city.label === item.label) === index && city)
    .filter(city => city)
    .map(city => ({ label: city?.label, value: city?.id.toString() }));
  cities?.unshift({ label: 'Все', value: 'all' });

  const addEventMode = id === ':id' ?
    ADD_EVENT_MODE.Create :
    location.pathname.match(ROUTES.BONUSES_COPY_EVENT.replace(':id', id)) ?
      ADD_EVENT_MODE.Copy :
      ADD_EVENT_MODE.Edit;

  const isDisabled = (eventCard?.status === 'Активна' || eventCard?.status === 'Одобрена') && addEventMode === ADD_EVENT_MODE.Edit;

  if (addEventMode === ADD_EVENT_MODE.Copy) {
    eventCard.customer_files = [];
    eventCard.to_all_customer = true;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (addEventMode === ADD_EVENT_MODE.Create) dispatch(actionsGetEvent.start());
    if (addEventMode === ADD_EVENT_MODE.Edit) dispatch(getEventById(id));
    if (addEventMode === ADD_EVENT_MODE.Copy) dispatch(getCopyEventById(id));
    dispatch(getBonusesCompany());
    dispatch(getBonusesBranches());
    dispatch(getBonusesPackages());
    dispatch(getTriggers());
    dispatch(getCmsPackages());
  }, // eslint-disable-next-line
    []);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (eventCard?.status === 'Активна' || eventCard?.status === 'Одобрена') dispatch(getBonusCardMailingTemplates(id));
  }, // eslint-disable-next-line
    [eventCard?.status]);

  const initialValues = {
    ...initialValuesForm(eventCard, companyBonuses, cities?.slice(1)), ...fields
  };

  const {
    handleSubmit,
    values,
    errors,
    handleChange,
    touched,
    isValid,
    setFieldValue,
    isSubmitting
    // eslint-disable-next-line react-hooks/rules-of-hooks
  } = useFormik({
    initialValues,
    validationSchema: validationSchema(isDisabled),
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      if (isSubmitting) {
        const fields = dataCreateEvent(
          values,
          uploadFiles,
          customTouched,
          addEventMode !== ADD_EVENT_MODE.Create,
          ENTITY,
          addEventMode === ADD_EVENT_MODE.Copy,
          cities?.slice(1)
        );

        if (addEventMode === ADD_EVENT_MODE.Create || addEventMode === ADD_EVENT_MODE.Copy) {
          dispatch(postCreateEvent(fields, moveToNextStep));
        }

        if (addEventMode === ADD_EVENT_MODE.Edit) {
          const cityId = fields.city_id;
          delete fields.city_id;
          if (fields.customer_files)
            if (eventCard.customer_files.length > fields.customer_files.length) delete fields['customer_files'];
            else fields.customer_files = fields.customer_files.map(item => { if (!eventCard.customer_files.map(item => item.id).includes(item)) return item }).filter(item => item);
          const fieldsForUpdateRequest = { ...fields, city_ids: cityId };

          if ((addEventMode === ADD_EVENT_MODE.Edit && (eventCard?.status === 'Создана' || eventCard?.status === 'На одобрении' || eventCard?.status === 'Доработка') && Object.keys(fields).length === 1 && fields.customer_files) ||
            Object.keys(fieldsForUpdateRequest).length === 1 && !fieldsForUpdateRequest.city_ids) redirectToBonuses();
          else if (Object.keys(fieldsForUpdateRequest).length) dispatch(updateEvent(id, fieldsForUpdateRequest)).then(res => res?.status === 200 && redirectToBonuses());
        }
      }
    }
  });

  const banner = cms?.find(item => item?.id === values?.package_id?.id)?.image;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    setService(values?.company?.services);
  }, [values?.company]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (values?.trigger?.slug === 'crm') {
      setFieldValue('to_all_customer', ENTITY[0].value);
      setEntity(ENTITY[0].value);
    } // eslint-disable-next-line
  }, [values.trigger]);

  // Temporary not showing, Task=382736
  // const packagesValidationArray = get(packages, '[0].data.packages', []);
  // const activationConditionsArray = get(packages, '[1].data.packages', []).map((item) => ({
  //   ...item,
  //   label: item?.code
  // }));
  const headerTitle = addEventMode === ADD_EVENT_MODE.Copy ?
    'Копировать событие' :
    addEventMode === ADD_EVENT_MODE.Edit ?
      'Редактировать событие' :
      'Добавить событие';
  const footerTitle = addEventMode === ADD_EVENT_MODE.Edit ? 'Сохранить' : 'Далее';

  const redirectToBonuses = () => history.push(ROUTES.BONUSES);

  const touchedById = (name) => addEventMode !== ADD_EVENT_MODE.Create && setCustomTouched({ [name]: true, ...customTouched });

  const registerInput = (name) => ({
    name,
    value: values[name],
    error: touched[name] && errors[name],

    ...mainStyleInput
  });

  const updateFieldData = (fetch, name) => {
    dispatch(fetch({ update: true })).then((res) => {
      if (res.status === 200) {
        setUpdatesFieldsStatus({
          ...updatesFieldsStatus,
          [name]: true
        });
      }
    });
  };

  const updateServiceInForm = (newService) => {
    setService([newService, ...service]);
  };

  const deleteServiceInform = (deleteId) => {
    setService(service.filter(({ id }) => id !== deleteId));
  };

  const handlerUploadFiles = (file) => {
    let formData = new FormData();
    formData.append('file', file[0]);

    return dispatch(postUploadFiles(formData, addEventMode === ADD_EVENT_MODE.Edit && (eventCard?.status === 'Создана' || eventCard?.status === 'На одобрении' || eventCard?.status === 'Доработка') ? id : undefined));
  };

  const handlerDeleteFiles = (file_id) => {
    return dispatch(deleteFiles(id, file_id));
  };

  const isPageVisible = visibleBySectionPermission(permissions, [PERMISSIONS.BONUS.ListBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value], 'or');
  const isCopyEventPageAccessible = visibleBySectionPermission(permissions, PERMISSIONS.BONUS.CopyBonusCards.value);
  const isCreateEventPageAccessible = visibleBySectionPermission(permissions, [PERMISSIONS.BONUS.UpdateBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value], 'or');
  const isSubmitDisabled = JSON.stringify(initialValues) === JSON.stringify(values) || fetching ||
    (!fetching && (addEventMode === ADD_EVENT_MODE.Edit ? !Object.values(customTouched).length || !isValid : !isValid));
  const isActiveSMSTemplate = addEventMode === ADD_EVENT_MODE.Edit && (eventCard?.status === 'Активна' || eventCard?.status === 'Одобрена') && !!bonusCardTemplates?.filter(item => item?.mailing_trigger?.name === 'Активация кампании')?.length;

  const dateExpiryError = () => {
    if (errors?.date_expiry?.dateExpiryNotValid && values.date_end) return errors?.date_expiry?.dateExpiryNotValid;
    if (errors?.date_expiry?.dateExpiryNotValid && values.date_start) return 'Дата старта больше, чем дата срока действия бонусов';
    if (values.date_expiry && new Date() > values.date_expiry) return 'Дата срока действия бонусов не может быть раньше текущей';
  }

  const dateEndError = () => {
    if (errors?.date_end?.dateEndNotValid && values.date_start) return errors?.date_end?.dateEndNotValid;
    if (values.date_end && new Date() > values.date_end) return 'Дата окончания не может быть раньше текущей';
  }

  if (addEventMode !== ADD_EVENT_MODE.Create ? !Object.values(eventCard).length : false) {
    return (
      <Box
        sx={{
          marginTop: '150px',
          textAlign: 'center'
        }}>
        <CircularProgress data-testid="CircularProgress" />
      </Box>
    );
  }

  if (
    !isPageVisible ||
    addEventMode === ADD_EVENT_MODE.Copy && !isCopyEventPageAccessible ||
    addEventMode === ADD_EVENT_MODE.Create && !isCreateEventPageAccessible
  ) {
    return <></>;
  }

  return (
    <Box id="add-event-step-1">
      <ModalCompany
        showModal={showModalCompany}
        setShowModal={setShowModalCompany}
        companyBonuses={companyBonuses}
        permission={visibleBySectionPermission(permissions, PERMISSIONS.BONUS.DeleteCampaign.value)}
      />
      <ModalService
        updateServiceInForm={updateServiceInForm}
        deleteServiceInform={deleteServiceInform}
        showModal={showModalService}
        setShowModal={setShowModalService}
        services={service}
        companyId={values?.company?.id}
        permission={visibleBySectionPermission(permissions, PERMISSIONS.BONUS.DeleteService.value)}
        errorModal={() => setErrorModal(true)}
      />
      <CustomModal
        opened={errorModal}
        modalClose={() => setErrorModal(false)}
        text="Удаление запрещено!"
        subText="Данная акция уже используется."
        cancelBtnName="Отмена"
        withoutSubmit
        icon={<ReportRedIcon />}
        data-testid="errorModal"
      />
      <CustomModal
        opened={isActiveSMSTemplateModal.open}
        modalClose={() => setIsActiveSMSTemplateModal({ open: false, hasOpened: true })}
        text="После изменения события загруженным абонентам будет отправлена SMS/Email рассылка по действующему шаблону по триггеру «Активация кампании»"
        cancelBtnName="Понятно"
        withoutSubmit
      />
      <Typography mb="24px" variant="h1" sx={{ color: 'text.primary' }} component="h1" data-testid="Title">
        {headerTitle}
      </Typography>
      <Breadcrumbs>
        <Link component={RouterLink} underline="hover" color="inherit" to={ROUTES.BONUSES}>
          Бонусы
        </Link>
        <Box>{headerTitle}</Box>
      </Breadcrumbs>

      <Paper sx={{ padding: '24px', marginTop: '24px' }}>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '34px' }}>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomSelect
                {...registerInput('trigger')}
                setFieldValue={setFieldValue}
                onChange={() => {
                  touchedById('trigger_id');
                  return handleChange;
                }}
                options={triggers?.filter(trigger => trigger?.name !== "Промокод")}
                placeholder="Триггер"
                disabled={isDisabled}
              />
              <Box>
                <Grid container flexWrap="nowrap" justifyContent="space-between">
                  <Box>
                    <CustomDateTimePicker
                      {...registerInput('date_start')}
                      setFieldValue={(name, val) => {
                        touchedById('date_start');
                        return setFieldValue(name, val);
                      }}
                      placeholder="Дата старта"
                      sx={{ width: '260px' }}
                      disabled={isDisabled}
                    />
                  </Box>
                  <Box>
                    <CustomDatePicker
                      {...registerInput('date_end')}
                      setFieldValue={(name, val) => {
                        touchedById('date_end');
                        return setFieldValue(name, val);
                      }}
                      placeholder="Дата окончания"
                      sx={{ width: '260px' }}
                      disabled={isDisabled}
                      dateStart={values.date_start}
                    />
                  </Box>
                </Grid>
                <Box color="error.main" fontSize="1rem" textAlign="center">
                  { dateEndError() || errors?.date_start?.dateStartNotValid }
                </Box>
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <CustomSelect
                  {...registerInput('company')}
                  sx={{ width: '448px' }}
                  onChange={() => {
                    setFieldValue('service_id', '');
                    touchedById('company');
                    return handleChange;
                  }}
                  setFieldValue={setFieldValue}
                  options={companyBonuses}
                  placeholder="Название кампании"
                  disabled={isDisabled}
                />
                {visibleBySectionPermission(permissions, PERMISSIONS.BONUS.CreateCampaign.value) && (
                  <Tooltip title="Настроить кампании" placement="top">
                    <SettingsIcon
                      cursor="pointer"
                      onClick={() => setShowModalCompany(true)}
                      data-testid="SettingsIconCampaign"
                    />
                  </Tooltip>
                )}
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <CustomSelect
                  {...registerInput('service_id')}
                  setFieldValue={setFieldValue}
                  sx={{ width: '448px' }}
                  options={service}
                  placeholder="Название акции"
                  disabled={service?.length === 0 || service === undefined || isDisabled}
                  onChange={() => {
                    touchedById('service_id');
                    return handleChange;
                  }}
                />
                {visibleBySectionPermission(permissions, PERMISSIONS.BONUS.CreateService.value) && (
                  <Tooltip title="Настроить акции" placement="top">
                    <SettingsIcon
                      cursor="pointer"
                      onClick={() => service === undefined || setShowModalService(true)}
                      data-testid="SettingsIconService"
                    />
                  </Tooltip>
                )}
              </Box>

              {values.type_events === TYPE_EVENTS[1].value && (
                <CustomSelect
                  {...registerInput('type_company')}
                  setFieldValue={setFieldValue}
                  options={TYPE_COMPANY}
                  placeholder="Тип кампании"
                  disabled={isDisabled}
                />
              )}

              {(values.trigger.slug === 'active' || values.trigger.slug === 'welcome' || values.trigger.slug === 'retention') && (
                <Grid container alignItems="center" justifyContent="space-between" columnGap="20px">
                  <Grid container gap="16px" sx={{ width: '448px' }}>
                    <CustomSelect
                      {...registerInput('package_id')}
                      setFieldValue={setFieldValue}
                      sx={{ width: '448px' }}
                      options={cms}
                      placeholder="Пакет"
                      onChange={() => {
                        touchedById('package_id');
                        return handleChange;
                      }}
                      disabled={isDisabled}
                    />
                  </Grid>
                  <Tooltip title="Обновить данные" placement="top">
                    <RestartAltIcon
                      onClick={() => updateFieldData(getCmsPackages, 'cms')}
                      sx={{
                        color: updatesFieldsStatus.cms ? 'success.main' : 'text.primary',
                        cursor: 'pointer'
                      }}
                      data-testid="RestartAltIcon"
                    />
                  </Tooltip>
                </Grid>
              )}

              {/*Temporary not showing, Task=382736*/}
              {/*{values.trigger.slug === 'active' && (*/}
              {/*  <Grid container alignItems="center" justifyContent="space-between" columnGap="20px">*/}
              {/*    <Grid container gap="16px" sx={{ width: '448px' }}>*/}
              {/*      <CustomSelect*/}
              {/*        {...registerInput('packages_validation')}*/}
              {/*        setFieldValue={setFieldValue}*/}
              {/*        sx={{ width: '448px' }}*/}
              {/*        options={packagesValidationArray}*/}
              {/*        placeholder="Проверка совместимости бонусов"*/}
              {/*        onChange={() => {*/}
              {/*          touchedById('packages_validation');*/}
              {/*          return handleChange;*/}
              {/*        }}*/}
              {/*        disabled={isDisabled}*/}
              {/*      />*/}
              {/*      <CustomSelect*/}
              {/*        {...registerInput('activation_conditions')}*/}
              {/*        setFieldValue={setFieldValue}*/}
              {/*        sx={{ width: '448px' }}*/}
              {/*        options={activationConditionsArray}*/}
              {/*        placeholder="Условия активации бонусов"*/}
              {/*        nameLabel="code"*/}
              {/*        onChange={() => {*/}
              {/*          touchedById('activation_conditions');*/}
              {/*          return handleChange;*/}
              {/*        }}*/}
              {/*        disabled={isDisabled}*/}
              {/*      />*/}
              {/*    </Grid>*/}
              {/*    <Tooltip title="Обновить данные" placement="top">*/}
              {/*      <RestartAltIcon*/}
              {/*        onClick={() => updateFieldData(getBonusesPackages, 'packages')}*/}
              {/*        sx={{*/}
              {/*          color: updatesFieldsStatus.packages ? 'success.main' : 'text.primary',*/}
              {/*          cursor: 'pointer'*/}
              {/*        }}*/}
              {/*        data-testid="RestartAltIconPackage"*/}
              {/*      />*/}
              {/*    </Tooltip>*/}
              {/*  </Grid>*/}
              {/*)}*/}

              {values?.trigger?.slug === 'welcome' && (
                <Grid container alignItems="center" justifyContent="space-between" columnGap="20px">
                  <Grid container gap="16px" sx={{ width: '448px' }}>
                    <CustomMultiSelect
                      {...registerInput('city_id')}
                      onChange={handleChange}
                      variant="outlined"
                      options={cities}
                      width={448}
                      placeholderColor="#667A8B"
                      setFieldValue={setFieldValue}
                      size="small"
                      placeholder="Города"
                      disabled={isDisabled}
                      touchedBy={() => touchedById('city_id')}
                      showAll={true}
                    />
                  </Grid>
                  <Tooltip title="Обновить данные" placement="top">
                    <RestartAltIcon
                      onClick={() => updateFieldData(getBonusesBranches, 'cities')}
                      sx={{
                        color: updatesFieldsStatus.cities ? 'success.main' : 'text.primary',
                        cursor: 'pointer'
                      }}
                      data-testid="RestartAltIcon"
                    />
                  </Tooltip>
                </Grid>
              )}
              <Box>
                <CustomDatePicker
                  {...registerInput('date_expiry')}
                  onChange={(e) => {
                    touchedById('date_expiry');
                    return handleChange(e);
                  }}
                  placeholder="Срок действия бонусов до"
                  setFieldValue={(name, val) => {
                    touchedById('date_expiry');
                    return setFieldValue(name, val);
                  }}
                  sx={{ width: '100%', zIndex: '0' }}
                  disabled={isDisabled}
                  dateEnd={values.date_end}
                  weekend
                />
                <Box color="error.main" fontSize="1rem" textAlign="center">{ dateExpiryError() }</Box>
              </Box>

              <Box>
                <CustomInputTextArea
                  {...registerInput('terms')}
                  onChange={(e) => {
                    touchedById('terms');
                    return handleChange(e);
                  }}
                  style={{ height: 120, width: '100%' }}
                  placeholder="Условия"
                  onPaste={e => e.clipboardData.getData('text').length > 1000 && e.preventDefault()}
                  disabled={isDisabled}
                />
                <Typography color={errors['terms'] && values['terms'] ? "error.main" : "text.secondary"}>До 1000 символов.</Typography>
              </Box>
              <CustomInput
                {...registerInput('bonus_add')}
                onChange={(e) => {
                  const input = e.target.value;
                  if (!input || /^[1-9]$/.test(input[0]))
                    if (!input || /^[0-9]$/.test(input[input.length - 1])) {
                      touchedById('bonus_add');
                      return handleChange(e);
                    }
                }}
                sx={{ zIndex: '0' }}
                placeholder="Количество бонусов"
                disabled={isDisabled}
              />
              <Typography color="error.main" fontSize="1rem">
                { errors?.bonus_add?.bonusesLimit }
              </Typography>
            </Box>
            <Box>
              {values.trigger.slug === 'retention' && (
                <>
                  <Box>
                    <NumericFormat
                      {...registerInput('customers_limit')}
                      name="customers_limit"
                      placeholder="Количество абонентов"
                      value={values.customers_limit}
                      sx={{ width: '100%', mb: '10px' }}
                      customInput={CustomInput}
                      allowedDecimalSeparators={['%']}
                      decimalScale={0}
                      allowLeadingZeros={false}
                      allowNegative={false}
                      thousandSeparator=" "
                      onChange={e => {
                        touchedById('customers_limit');
                        return handleChange(e);
                      }}
                      disabled={isDisabled}
                    />
                    <Box color="error.main" fontSize="1rem" textAlign="center">
                      { errors?.customers_limit?.customersLimitError }
                    </Box>
                  </Box>
                  <Typography variant="subtitleForm" data-testid="toAll">Начислить абонентам</Typography>
                  <Box sx={{ mt: '10px' }}>
                  <UploadFiles
                    name="customer_files"
                    defaultFiles={values?.customer_files}
                    setFieldValue={(name, newFiles) => {
                      touchedById('customer_files');
                      return setFieldValue(name, newFiles);
                    }}
                    description="Форматы для загрузки: xls, xlsx."
                    uploadFetch={handlerUploadFiles}
                    validationUpload={validationFiles}
                    deleteFetch={(eventCard?.status === 'Создана' || eventCard?.status === 'На одобрении' || eventCard?.status === 'Доработка') && addEventMode === ADD_EVENT_MODE.Edit ? handlerDeleteFiles : null}
                    isAllowedToRemoveFile={!isDisabled}
                    resultModal={isActiveSMSTemplate && !isActiveSMSTemplateModal.hasOpened ? (() => setIsActiveSMSTemplateModal({ open: true, hasOpened: false })) : undefined}
                  />
                  </Box>
                </>
              )}
              {(values.trigger.slug === 'active' || values.trigger.slug === 'welcome') && (<>
                <Typography variant="subtitleForm" data-testid="toAll">Начислить абонентам</Typography>
                <CustomRadioGroup
                  name="to_all_customer"
                  sx={{ mb: '6px' }}
                  options={[ENTITY[0], ENTITY[2]]}
                  value={
                    typeof values?.to_all_customer === 'boolean'
                      ? values?.to_all_customer
                        ? ENTITY[0].value
                        : ENTITY[2].value
                      : entity
                  }
                  onChange={(e) => {
                    setEntity(e);
                    touchedById('to_all_customer');
                  }}
                  setFieldValue={setFieldValue}
                  disabled={values?.trigger?.slug === 'crm' || isDisabled}
                />
                {(typeof values?.to_all_customer === 'boolean'
                  ? !values?.to_all_customer
                  : values?.to_all_customer === ENTITY[2].value) && (
                  <UploadFiles
                    name="customer_files"
                    defaultFiles={values?.customer_files}
                    setFieldValue={(name, newFiles) => {
                      touchedById('customer_files');
                      return setFieldValue(name, newFiles);
                    }}
                    description="Форматы для загрузки: xls, xlsx."
                    uploadFetch={handlerUploadFiles}
                    deleteFetch={(eventCard?.status === 'Создана' || eventCard?.status === 'На одобрении' || eventCard?.status === 'Доработка') && addEventMode === ADD_EVENT_MODE.Edit ? handlerDeleteFiles : null}
                    validationUpload={validationFiles}
                    isAllowedToRemoveFile={!isDisabled}
                    resultModal={isActiveSMSTemplate && !isActiveSMSTemplateModal.hasOpened ? (() => setIsActiveSMSTemplateModal({ open: true, hasOpened: false })) : undefined}
                  />
                )}
              </>)}
              {/*(typeof values?.to_all_customer === 'boolean'
                ? !values?.to_all_customer
                : values?.to_all_customer === ENTITY[1].value) && (
                <NumericFormat
                  {...registerInput('participants_add')}
                  name="participants_add"
                  placeholder="Количество участников"
                  value={values.participants_add}
                  sx={{ width: '100%', mb: '10px' }}
                  customInput={CustomInput}
                  allowedDecimalSeparators={['%']}
                  decimalScale={0}
                  allowLeadingZeros={false}
                  allowNegative={false}
                  thousandSeparator=" "
                  onChange={e => {
                    touchedById('participants_add');
                    return handleChange(e);
                  }}
                />
              )*/}
              {values.trigger.slug !== 'retention' && (
                <Box
                  sx={{ mt: values.trigger.slug === 'active' || values.trigger.slug === 'welcome' ? '32px' : undefined }}>
                  <CustomSwitch
                    {...registerInput('add_if_debt_exist')}
                    setFieldValue={setFieldValue}
                    label="Начислять при наличии задолженности по услугам постоплаты"
                    checked={values.add_if_debt_exist}
                    onChange={(e) => {
                      touchedById('add_if_debt_exist');
                      return handleChange(e);
                    }}
                    disabled={isDisabled}
                  />
                </Box>
              )}

              {/* Start Promocodes */}
              {(values.trigger.slug === 'welcome') && (
                <Box sx={{ mt: '32px' }}>
                  <Typography variant="subtitleForm">Промокоды</Typography>
                  
                  <Typography sx={{ fontWeight: 400, fontSize: '18px' }}>
                    Сформировать единый промокод
                  </Typography>
                  <Box sx={{ mt: '8px' }}>
                    <CustomInput
                      {...registerInput('universal_promocode')}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (!input || /^[a-zA-Z0-9]+$/.test(input[0]))
                          touchedById('universal_promocode');
                          return handleChange(e);
                      }}
                      sx={{ zIndex: '0', width: '100%' }}
                      placeholder="Количество бонусов"
                      disabled={isDisabled}
                    />
                  </Box>
                  <Typography sx={{ fontWeight: 400, fontSize: '18px' }}>
                    Ссылка для перехода
                  </Typography>
                  <Box sx={{ mt: '8px' }}>
                    <CustomInput
                      {...registerInput('site_url')}
                      onChange={(e) => {
                            touchedById('site_url');
                            return handleChange(e);
                      }}
                      sx={{ zIndex: '0', width: '100%' }}
                      placeholder="Количество бонусов"
                      disabled={isDisabled}
                    />
                  </Box>

                </Box>
              )}
              {/* End Promocodes */}
              
              {(values.trigger.slug === 'active' || values.trigger.slug === 'welcome' || values.trigger.slug === 'retention') && (
                  <Box sx={{ mt: '32px' }}>
                    <Typography variant="subtitleForm">Баннер</Typography>
                    {values.package_id ?
                      <Box sx={{ mt: '16px' }}>
                        <Box
                          component="img"
                          alt="Баннер пакета"
                          src={getAssetUrl(banner)}
                          sx={{
                            borderRadius: '8px',
                            width: '240px',
                            height: '240px'
                          }}
                        />
                      </Box>
                      :
                      <Typography mt="16px" color="text.secondary" sx={{ fontSize: '16px' }}>Нет данных. Выберите пакет</Typography>
                    }
                  </Box>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '24px'
            }}>
            <Typography color="error.main" width="500px">
              {errorCard?.detail && (typeof errorCard?.detail === 'string' ? errorCard?.detail : JSON.stringify(errorCard?.detail)) || (typeof errorCard === 'string' && errorCard)}
            </Typography>

            <Box>
              <CustomButton
                type="submit"
                size="large"
                color="secondary"
                variant="contained"
                component={RouterLink}
                to={ROUTES.BONUSES}>
                Отмена
              </CustomButton>

              <CustomButton
                type="submit"
                sx={{ marginLeft: '16px', width: '146px' }}
                size="large"
                variant="contained"
                disabled={isSubmitDisabled}
              >
                {footerTitle}
              </CustomButton>
            </Box>
          </Box>
        </form>
      </Paper>
    </Box>
  )
}

AddEventFirstStep.propTypes = {
  moveToNextStep: PropTypes.func,
  fields: PropTypes.object,
}
